const fiilMudhori = [
  {
    title: { en: '4 Letters', ms: '4 Huruf' },
    shapes: [
      {
        madhi: 'فَاعَلَ',
        mudhori: 'يُفَاعِلُ',
      },
      {
        madhi: 'أَفْعَلَ',
        mudhori: 'يُفْعِلُ',
      },
      {
        madhi: 'فَعَّلَ',
        mudhori: 'يُفَعِّلُ',
      },
    ],
    examples: [
      {
        madhi: { ar: 'رَاجَعَ', en: 'Revised', ms: 'Ulangkaji' },
        mudhori: { ar: 'يُرَاجِعُ', en: 'Revise', ms: 'Ulangkaji' },
      },
      {
        madhi: { ar: 'أَدْخَلَ', en: 'Entered', ms: 'Masuk' },
        mudhori: { ar: 'يُدْخِلُ', en: 'Enter', ms: 'Masuk' },
      },
      {
        madhi: { ar: 'نَظَّفَ', en: 'Cleaned', ms: 'Bersihkan' },
        mudhori: { ar: 'يُنَظِّفُ', en: 'Clean', ms: 'Bersihkan' },
      },
    ],
  },
  {
    title: { en: '5 Letters', ms: '5 Huruf' },
    shapes: [
      {
        madhi: 'تَفَاعَلَ',
        mudhori: 'يَتَفَاعَلُ',
      },
      {
        madhi: 'اِفْتَعَلَ',
        mudhori: 'يَفْتَعِلُ',
      },
      {
        madhi: 'تَفَعَّلَ',
        mudhori: 'يَتَفَعَّلُ',
      },
    ],
    examples: [
      {
        madhi: { ar: 'تَنَاوَلَ', en: 'Took', ms: 'Mengambil' },
        mudhori: { ar: 'يَتَنَاوَلُ', en: 'Take', ms: 'Mengambil' },
      },
      {
        madhi: { ar: 'اِغْتَسَلَ', en: 'Bathed', ms: 'Mandi' },
        mudhori: { ar: 'يَغْتَسِلُ', en: 'Bath', ms: 'Mandi' },
      },
      {
        madhi: { ar: 'تَعَلَّمَ', en: 'Learned', ms: 'Belajar' },
        mudhori: { ar: 'يَتَعَلَّمُ', en: 'Learn', ms: 'Belajar' },
      },
    ],
  },
  {
    title: { en: '6 Letters', ms: '6 Huruf' },
    shapes: [
      {
        madhi: 'اِسْتَفْعَلَ',
        mudhori: 'يَسْتَفْعِلُ',
      },
    ],
    examples: [
      {
        madhi: { ar: 'اِسْتَيْقَظَ', en: 'Woke Up', ms: 'Bangun dari Tidur' },
        mudhori: { ar: 'يَسْتَيْقِظُ', en: 'Wake Up', ms: 'Bangun dari Tidur' },
      },
    ],
  },
];

export default fiilMudhori;
